// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"c4638e20","302":"717a3485","338":"e462757f","383":"b57f120d","559":"97202afe","772":"62ec47da","851":"27349367"}[chunkId] + ".chunk.js";
};